import { lazy, Suspense } from 'react';

// we have lazy loading not to load the devtools code on production
const Devtools = lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then((d) => ({
    default: d.ReactQueryDevtools,
  })),
);

function QueryDevTools() {
  return (
    <Suspense fallback={null}>
      <Devtools buttonPosition={'bottom-left'} />
    </Suspense>
  );
}

export { QueryDevTools };
